import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';

import { useGetTunnelActionsQuery } from 'api/main';
import { newActionSet } from 'reducers/customTunnel';
import { customTunnelSelectors } from 'reducers';
import { alertType } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import AddAction from './AddAction';
import ActionItem from './ActionItem';
import { ActionButton, Loader } from 'components';
import { Box } from '@mui/material';

const TunnelStepActions = ({ ppTunnelId, pmTunnelId }) => {
    const dispatch = useDispatch();
    const newAction = useSelector(customTunnelSelectors.getNewAction);
    const { ppId: editingActionId } = useSelector(customTunnelSelectors.getEditingActionId);

    const { data: ppActions = [], isLoading: ppActionsLoading } = useGetTunnelActionsQuery(
        { tunnel: ppTunnelId },
        { skip: !ppTunnelId }
    );

    const handleAddNewAction = useCallback(() => {
        dispatch(
            newActionSet({
                name: '',
                questions: [],
                conditions: [],
                alertType: alertType.WARNING,
                alertMessage: '',
                wrongCharacter: false,
            })
        );
    }, [dispatch]);

    return (
        <Box>
            <Box textAlign="center" mb={2}>
                <ActionButton
                    variant="contained"
                    onClick={handleAddNewAction}
                    disabled={!!newAction || !!editingActionId}
                >
                    {texts.ADD_ACTION}
                </ActionButton>
            </Box>
            <Loader loading={ppActionsLoading}>
                {ppActions.map(action => (
                    <ActionItem
                        key={action.id}
                        ppTunnelId={ppTunnelId}
                        pmTunnelId={pmTunnelId}
                        action={action}
                    />
                ))}
            </Loader>
            {!!newAction && <AddAction ppTunnelId={ppTunnelId} pmTunnelId={pmTunnelId} />}
        </Box>
    );
};

TunnelStepActions.propTypes = {
    ppTunnelId: PropTypes.number,
    pmTunnelId: PropTypes.number,
};

export default TunnelStepActions;
